// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * FRONT-15: CSS pour l'onglet Bancaire V2 - DA Centralis
 * - Section banners #595959
 * - Orange accent #f97316
 * - Error/required badge #ef4444
 * - Text #374151, secondary #6b7280
 */

.tab-bancaire {
  /* Carte / fond blanc retires : les sections (SectionPliable) portent leur propre cadre. */
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.tab-header h2 {
  margin: 0;
  font-size: 2rem;
  font-weight: 600;
  color: #1f2937;
}

/* FRONT-15: Blocs de section avec banniere DA Centralis */
/* .form-section-block : structure remplacee par SectionPliable (cadre porte par
   le composant). Regles supprimees pour ne pas laisser de border residuel. */

/* FRONT-15: Banniere de section - DA Centralis #595959 */
.section-banner {
  background-color: #595959;
  color: #fff;
  padding: 1.25rem 1.5rem;
  font-size: 1.6rem;
  font-weight: 600;
  /* text-transform: uppercase; */
  /* letter-spacing: 0.05em; */
}

.section-content {
  padding: 1.5rem;
  /* background: #f9fafb; */
}

/* FRONT-15: Sections contact en mode lecture */
.contact-section {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px dashed #e5e7eb;
}

.contact-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.contact-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.contact-header h4 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
}

/* FRONT-15: Pastille rouge pour sections incompletes - DA Centralis #ef4444 */
.required-badge {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #ef4444;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Form subsections */
.form-subsection {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px dashed #e5e7eb;
}

.form-subsection:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.form-subsection h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 1rem 0;
}

.subsection-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.subsection-header h4 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
}

/* Info grid (mode lecture) */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1.5rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-item label {
  font-size: 1.1rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.info-item > span {
  font-size: 1.4rem;
  color: #1f2937;
}

/* Astérisque rouge en mode lecture */
.tab-bancaire .required-asterisk {
  color: #dc2626;
  font-weight: bold;
  margin-left: 0.25rem;
}

.iban-value {
  font-family: "Courier New", Courier, monospace;
  letter-spacing: 0.05em;
  word-break: break-all;
  max-width: 100%;
}

/* FRONT-15: Text pour sections vides */
.empty-section-text {
  font-size: 0.95rem;
  color: #6b7280;
  font-style: italic;
  margin: 0;
}

/* FRONT-15: Status conditions */
.conditions-status {
  margin-bottom: 1rem;
}

.conditions-accepted {
  color: #16a34a;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}

.conditions-accepted::before {
  content: "✓";
  font-weight: bold;
}

.conditions-not-accepted {
  color: #374151;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}

/* Notice bancaire */
.bancaire-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
}

.bancaire-notice p {
  margin: 0;
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.5;
}

/* Mode edition */
.bancaire-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-intro {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
}

.form-intro p {
  margin: 0;
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.5;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
}

.form-group input {
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1.4rem;
  color: #1f2937;
  background: #fff;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  letter-spacing: 0.025em;
}

.form-group input:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.form-group input::placeholder {
  color: #9ca3af;
  font-family: inherit;
}

/* FRONT-15: Erreurs - DA Centralis #ef4444 */
.form-group.has-error input {
  border-color: #ef4444;
}

.form-group.has-error input:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.error-message {
  font-size: 0.8rem;
  color: #ef4444;
  margin-top: 0.25rem;
}

.field-hint {
  font-size: 0.75rem;
  color: #6b7280;
}

/* FRONT-15: Checkbox acceptation conditions */
.checkbox-group {
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
}

.checkbox-group.has-error {
  border-color: #ef4444;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: #f97316;
}

.checkbox-text {
  font-size: 1.2rem;
  color: #374151;
  line-height: 1.5;
  text-align: justify;
}

/* FRONT-15: Checkbox inline sous email facturation */
.checkbox-group-inline {
  margin-top: 1rem;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
}

.checkbox-group-inline.has-error {
  border-color: #ef4444;
}

/* FRONT-15: Conditions inline en mode lecture */
.conditions-inline {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed #e5e7eb;
}

/* Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

/* Responsive */
@media (max-width: 768px) {
  .tab-bancaire {
    padding: 1rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .info-grid {
    grid-template-columns: 1fr 1fr;
  }

  .checkbox-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .info-grid {
    grid-template-columns: 1fr;
  }

  .tab-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions button {
    width: 100%;
  }
}

/* FRONT-20: Styles pour TVA obligatoire */
.warning-text {
  color: #f97316;
  font-style: italic;
  font-size: 0.9rem;
}

label .required {
  color: #ef4444;
  margin-left: 4px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/tabs/TabBancaire.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;6EAC6E;;AAE7E,yDAAyD;AACzD;EACE,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB;;mBAEiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,0CAA0C;AAC1C;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/**\n * FRONT-15: CSS pour l'onglet Bancaire V2 - DA Centralis\n * - Section banners #595959\n * - Orange accent #f97316\n * - Error/required badge #ef4444\n * - Text #374151, secondary #6b7280\n */\n\n.tab-bancaire {\n  /* Carte / fond blanc retires : les sections (SectionPliable) portent leur propre cadre. */\n}\n\n.tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.tab-header h2 {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n/* FRONT-15: Blocs de section avec banniere DA Centralis */\n/* .form-section-block : structure remplacee par SectionPliable (cadre porte par\n   le composant). Regles supprimees pour ne pas laisser de border residuel. */\n\n/* FRONT-15: Banniere de section - DA Centralis #595959 */\n.section-banner {\n  background-color: #595959;\n  color: #fff;\n  padding: 1.25rem 1.5rem;\n  font-size: 1.6rem;\n  font-weight: 600;\n  /* text-transform: uppercase; */\n  /* letter-spacing: 0.05em; */\n}\n\n.section-content {\n  padding: 1.5rem;\n  /* background: #f9fafb; */\n}\n\n/* FRONT-15: Sections contact en mode lecture */\n.contact-section {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px dashed #e5e7eb;\n}\n\n.contact-section:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.contact-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.contact-header h4 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n/* FRONT-15: Pastille rouge pour sections incompletes - DA Centralis #ef4444 */\n.required-badge {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  background-color: #ef4444;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* Form subsections */\n.form-subsection {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px dashed #e5e7eb;\n}\n\n.form-subsection:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.form-subsection h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 1rem 0;\n}\n\n.subsection-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.subsection-header h4 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n/* Info grid (mode lecture) */\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.info-item label {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.info-item > span {\n  font-size: 1.4rem;\n  color: #1f2937;\n}\n\n/* Astérisque rouge en mode lecture */\n.tab-bancaire .required-asterisk {\n  color: #dc2626;\n  font-weight: bold;\n  margin-left: 0.25rem;\n}\n\n.iban-value {\n  font-family: \"Courier New\", Courier, monospace;\n  letter-spacing: 0.05em;\n  word-break: break-all;\n  max-width: 100%;\n}\n\n/* FRONT-15: Text pour sections vides */\n.empty-section-text {\n  font-size: 0.95rem;\n  color: #6b7280;\n  font-style: italic;\n  margin: 0;\n}\n\n/* FRONT-15: Status conditions */\n.conditions-status {\n  margin-bottom: 1rem;\n}\n\n.conditions-accepted {\n  color: #16a34a;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.conditions-accepted::before {\n  content: \"✓\";\n  font-weight: bold;\n}\n\n.conditions-not-accepted {\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n/* Notice bancaire */\n.bancaire-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #fff;\n  border-radius: 0.5rem;\n  border: 1px solid #e5e7eb;\n}\n\n.bancaire-notice p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n/* Mode edition */\n.bancaire-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-intro {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #fff;\n  border-radius: 0.5rem;\n  border: 1px solid #e5e7eb;\n}\n\n.form-intro p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.25rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.form-group input {\n  padding: 0.75rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 1.4rem;\n  color: #1f2937;\n  background: #fff;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n  letter-spacing: 0.025em;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.form-group input::placeholder {\n  color: #9ca3af;\n  font-family: inherit;\n}\n\n/* FRONT-15: Erreurs - DA Centralis #ef4444 */\n.form-group.has-error input {\n  border-color: #ef4444;\n}\n\n.form-group.has-error input:focus {\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.error-message {\n  font-size: 0.8rem;\n  color: #ef4444;\n  margin-top: 0.25rem;\n}\n\n.field-hint {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n/* FRONT-15: Checkbox acceptation conditions */\n.checkbox-group {\n  padding: 1rem;\n  background: #fff;\n  border-radius: 0.5rem;\n  border: 1px solid #e5e7eb;\n}\n\n.checkbox-group.has-error {\n  border-color: #ef4444;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n  flex-shrink: 0;\n  accent-color: #f97316;\n}\n\n.checkbox-text {\n  font-size: 1.2rem;\n  color: #374151;\n  line-height: 1.5;\n  text-align: justify;\n}\n\n/* FRONT-15: Checkbox inline sous email facturation */\n.checkbox-group-inline {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #fff;\n  border-radius: 0.5rem;\n  border: 1px solid #e5e7eb;\n}\n\n.checkbox-group-inline.has-error {\n  border-color: #ef4444;\n}\n\n/* FRONT-15: Conditions inline en mode lecture */\n.conditions-inline {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px dashed #e5e7eb;\n}\n\n/* Actions */\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .tab-bancaire {\n    padding: 1rem;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .checkbox-text {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tab-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .form-actions button {\n    width: 100%;\n  }\n}\n\n/* FRONT-20: Styles pour TVA obligatoire */\n.warning-text {\n  color: #f97316;\n  font-style: italic;\n  font-size: 0.9rem;\n}\n\nlabel .required {\n  color: #ef4444;\n  margin-left: 4px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
